import React, { useRef, useEffect, useMemo } from "react";
import { Container } from "reactstrap";
import cn from "classnames";

export default function HubSpotForm({
  customClass,
  form_src,
  portal_id = "144452896",
  form_id,
  successPageUrl,
}) {
  
  // Create a unique ID for the container per component instance
  const containerId = useMemo(
    () => `hubspot-form-container-${Math.random().toString(36).substring(2, 10)}`,
    []
  );

  const formRenderedRef = useRef(false);

  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) {
      console.error(`Missing form container: #${containerId}`);
      return;
    }

    if (formRenderedRef.current) {
      console.log("Form already rendered, skipping...");
      return;
    }

    const loadAndRenderForm = () => {
      const container = document.getElementById(containerId);
      if (container) container.innerHTML = "";
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: portal_id,
          formId: form_id,
          target: `#${containerId}`,
          onFormSubmitted: function () {
            if (successPageUrl) {
              window.location.href = `${successPageUrl}`;
            } else {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          },
        });
        formRenderedRef.current = true;
      }
    };

    const existingScript = document.querySelector(
      'script[src*="js-eu1.hsforms.net/forms/embed/v2.js"]'
    );

    if (existingScript) {
      if (window.hbspt) {
        loadAndRenderForm();
      } else {
        existingScript.addEventListener("load", loadAndRenderForm);
      }
    } else {
      const script = document.createElement("script");
      script.src = "//js-eu1.hsforms.net/forms/embed/v2.js";
      script.async = true;
      script.onload = loadAndRenderForm;
      script.onerror = () => {
        console.error("Failed to load HubSpot form script.");
      };
      document.body.appendChild(script);
    }
  }, [form_id, containerId]);

  return (
    <>
      <section className={cn(customClass, "mt-5")}>
        <Container>
          <div className="hbspt-form" id={containerId}></div>
        </Container>
      </section>
    </>
  );
}
